import {
  Comment,
  CreateCommentPayload,
  UpdateCommentPayload,
} from "./models/comments.models";
import axiosInstance from "./axios";
import { validateWithSchema } from "./zodUtils";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchChat = async (
  bearerToken,
  reportId?: number
): Promise<Comment[]> => {
  try {
    const url = `${apiUrl}/Admin/comments/chat/${reportId}`;

    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch akeneo models:", error);
    throw error;
  }
};

export const postComment = async (
  bearerToken: string,
  payload: CreateCommentPayload
): Promise<Comment> => {
  try {
    const url = `${apiUrl}/Admin/comments`;

    const response = await axiosInstance.post(url, payload, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch akeneo model:", error);
    throw error;
  }
};

export const updateComment = async (
  bearerToken: string,
  payload: UpdateCommentPayload
): Promise<Comment> => {
  try {
    const url = `${apiUrl}/Admin/comments/${payload.id}`;

    const response = await axiosInstance.put(url, payload, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch akeneo model:", error);
    throw error;
  }
};

export const deleteComment = async (
  bearerToken: string,
  commentId: number
): Promise<void> => {
  try {
    const url = `${apiUrl}/Admin/comments/${commentId}`;

    await axiosInstance.delete(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
  } catch (error) {
    console.error("Failed to delete comment:", error);
    throw error;
  }
};
